import { appendEvent, lastGameAction, projectGame, type Game } from './game'
import { db } from './storage'

export type GamePanelCommand =
  | { type: 'sub'; out: string; in: string }
  | { type: 'foul'; playerId: string; delta: -1 | 1 }
  | { type: 'pause' | 'resume' }
  | { type: 'undo'; target: string }

// Read and append within the same transaction so panel actions cannot overwrite
// a change from another tab or from the full game-management screen.
export async function applyGamePanelCommand(id: string, command: GamePanelCommand): Promise<Game> {
  return db.transaction('rw', db.games, async () => {
    const game = await db.games.get(id)
    if (!game) throw new Error('This game is no longer available. Open game setup to continue.')
    const now = Date.now(), state = projectGame(game,now)
    if (command.type === 'sub' && state.fouls[command.in] >= game.foulLimit) throw new Error('This substitute has fouled out. Choose another player.')
    if (command.type === 'foul') {
      const fouls = state.fouls[command.playerId] || 0
      if (command.delta < 0 && fouls === 0) throw new Error('This player has no fouls to remove.')
      if (command.delta > 0 && fouls >= game.foulLimit) throw new Error('This player is already at the foul limit.')
    }
    if (command.type === 'undo' && lastGameAction(game)?.id !== command.target) throw new Error('The game has changed. Review the latest action before undoing it.')
    const next = appendEvent(game,command,now)
    await db.games.put(next)
    return next
  })
}
